import { HStack, Text, Link, useColorMode } from '@chakra-ui/react'
import React from 'react'
import { getTokens } from '../config/colorTokens'

const Footer = () => {
    const { colorMode } = useColorMode()
    const t = getTokens(colorMode)

    return (
        <HStack p={3} justifyContent="center">
            <Text
                color={t.textSecondary}>
                Copyright © {new Date().getFullYear()} <Link
                    href="https://prasoonsoni.in"
                    target="_blank">
                    Prasoon Soni
                </Link>
            </Text>
        </HStack>
    )
}

export default Footer